import { FileDto, Mark43File } from '@mark43/cad-api';
import { getRealUrlPrefix } from '@m43/core';

export function getFilePath(
    file: FileDto | Mark43File | undefined,
    mediaAttachmentsEnabled: boolean
): string {
    if (!mediaAttachmentsEnabled) {
        // For exports, we intentionally keep using `fileAppServerPath` when attachments are OFF.
        // `fileWebServerPath` links expire after 50 minutes and want to preserve existing behavior for now when attachments is off.
        return file?.fileAppServerPath || '';
    }
    const path = file?.fileWebServerPath || '';

    if (!path) {
        return '';
    }

    const prefix = getRealUrlPrefix();
    if (!prefix) {
        return '';
    }

    // `new URL(relative, base)` treats a base without a trailing slash as a "file" URL and
    // replaces the last path segment during resolution.
    // Example:
    //   new URL('s3/file.jpg', 'https://example.com/api').toString() => 'https://example.com/s3/file.jpg'   (drops '/api')
    // Ensuring the base ends with '/' forces it to be treated as a directory base.
    const base = prefix.endsWith('/') ? prefix : `${prefix}/`;

    try {
        return new URL(path, base).toString();
    } catch {
        return '';
    }
}
